import React from 'react';

const DashboardMedicationCard = props => {
  return (
    <div className="medicine ac">
      <h4 className="ac-trigger medicine-name ac-header">{props.name}
        <button className="content__accordion-title-button styleless-button" />
      </h4>
      <div className="ac-panel">
        <span className="directions">{props.patientSig}</span>
        {/* this data is coming from drupal which escapes XSS so this is ok. */}
        <div
          className="medication-link"
          dangerouslySetInnerHTML={{ __html: props.viewDetailsHTML }}
        />
      </div>
    </div>
  );
};

export default DashboardMedicationCard;
